/* Hook that connects the game to the app lobby and auth. Provides menuProps 
(play solo/multiplayer/new game/back/restart/start), renderBoard() (home, countdown, solo/multiplayer views),
 and posts solo results to the backend when finished  */
import React from 'react';
import SpellingBlitz from './SpellingBlitz';
import { generateSeed, BACKEND_URL } from '../../core/utils';

export function useSpellingBlitzOrchestrator(lobby, auth) {

  const renderBlurredBoard = () => (
    <div className="blurred-board">
      <SpellingBlitz
        seed={'PLACEHOLDER'}
        onScore={() => {}}
        timerSeconds={120}
        autoStart={false}
      />
    </div>
  );

  const handlePlaySolo = () => {
    lobby.setGameMode('solo');
    lobby.setGameState('playing');
    lobby.setGameSeed(generateSeed());
    lobby.setGameKey(prev => prev + 1);
  };

  const handleSoloGameEnd = async (result) => {
    try {
      if (auth.authToken && result && result.score !== undefined) {
        await fetch(`${BACKEND_URL}/api/solo/results`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth.authToken}`,
          },
          body: JSON.stringify({ score: result.score }),
        });
      }
    } catch (e) {}
  };

  const handlePlayWithFriends = () => {
    lobby.setGameMode('multiplayer');
    lobby.setGameState('home');
  };

  const handleBackToMenu = () => {
    lobby.resetToMenu();
  };

  const handleNewGame = (seed) => {
    const finalSeed = (seed && typeof seed === 'string' && seed.trim()) ? seed.trim() : generateSeed();
    lobby.setGameSeed(finalSeed);
    lobby.setGameKey(prev => prev + 1);
  };

  const handleMultiplayerScore = (score) => {
    lobby.handleMultiplayerScore(score);
  };

  const renderCountdownOverlay = () => (
    <div className="lobby-stage">
      {renderBlurredBoard()}
      <div className="countdown-overlay lobby-overlay">
        <div className="countdown-circle">
          <div className="countdown-number">{lobby.countdownValue}</div>
        </div>
        <p className="countdown-text">Get Ready!</p>
      </div>
    </div>
  );

  const showBlurredHome = (lobby.gameMode === '' || lobby.gameMode === 'multiplayer') && lobby.gameState === 'home';

  const renderBoard = () => (
    <>
      {showBlurredHome && renderBlurredBoard()}

      {lobby.gameMode === 'solo' && lobby.gameState === 'playing' && (
        <SpellingBlitz
          key={lobby.gameKey}
          seed={lobby.gameSeed}
          onScore={() => {}}
          onGameEnd={handleSoloGameEnd}
          timerSeconds={120}
          autoStart={true}
        />
      )}

      {lobby.gameMode === 'multiplayer' && (
        <>
          {lobby.gameState === 'lobby' && renderBlurredBoard()}

          {lobby.gameState === 'countdown' && renderCountdownOverlay()}

          {(lobby.gameState === 'playing' || lobby.gameState === 'finished') && (
            <SpellingBlitz
              key={`mp-${lobby.gameKey}`}
              seed={lobby.gameSeed}
              onScore={handleMultiplayerScore}
              timerSeconds={120}
              autoStart={true}
            />
          )}
        </>
      )}
    </>
  );

  const menuProps = {
    onPlaySolo: handlePlaySolo,
    onPlayZen: handlePlaySolo,
    onPlayWithFriends: handlePlayWithFriends,
    onBackToMainMenu: handleBackToMenu,
    onNewGame: handleNewGame,
    onRestartGame: lobby.restartGame,
    onStartGame: lobby.startGame,
  };

  return { menuProps, renderBoard, className: 'sb-app', gameboardClassName: 'sb-gameboard-area' };
}
